<template>
    <div class="mt-2 summary">Всего:  {{sumTimesFormatted}}</div>
</template>

<script>
import formatInterval from '../helpers/formatInterval'
export default {
  name: 'StatsOrderSummaryRow',
  props: {
    stats: Array
  },
  computed: {
    sumTimesFormatted () {
      let sum = this.sumIntervals(this.stats)
      return this.formatInterval(sum)
    }
  },
  methods: {
    sumIntervals (intervals) {
      let accum = null
      let firstEl = true
      intervals.forEach((item, index) => {
        let interval = item.timeAvg
        if (interval !== null) {
          if (firstEl) {
            accum = Object.assign({}, interval)
            firstEl = false
          } else {
            accum.years += interval.years
            accum.months += interval.months
            accum.days += interval.days
            accum.hours += interval.hours
            accum.minutes += interval.minutes
            accum.seconds += interval.seconds
          }
        }
      })
      if (accum) {
        let discharge = Math.floor(accum.seconds / 60)
        accum.minutes += discharge
        accum.seconds -= discharge * 60
        discharge = Math.floor(accum.minutes / 60)
        accum.hours += discharge
        accum.minutes -= discharge * 60
        discharge = Math.floor(accum.hours / 24)
        accum.days += discharge
        accum.hours -= discharge * 24
      }
      return accum
    },
    formatInterval: formatInterval
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatsOrderSummaryRow.vue